import React from 'react'
import './RegexMatchDashboard.css'
import {Card, CardContent, List, ListItem, ListItemIcon} from '@material-ui/core'
import {Cancel, CheckCircle} from '@material-ui/icons'

const RegexMatchDashboard = props => {
    const returnSuccess = message => {
        return (
            <ListItem className="regexdash-content__li success">
                <ListItemIcon className="cross-icon">
                    <CheckCircle />
                </ListItemIcon>
                {message}
            </ListItem>
        )
    }

    const returnIncomplete = message => {
        return (
            <ListItem className="regexdash-content__li incomplete">
                <ListItemIcon className="cross-icon">
                    <Cancel />
                </ListItemIcon>
                {message}
            </ListItem>
        )
    }

    const checkValidation = (regex, message, compareTo) => {
        if (regex === 'Compare') {
            return props.value && props.value === props.compareTo
                ? returnSuccess(message)
                : returnIncomplete(message)
        } else
            return props.value.match(regex)
                ? returnSuccess(message)
                : returnIncomplete(message)
    }
    return (
        <Card className="reset-password__regexdash--wrapper">
            <CardContent className="regexdash-content-wrapper">
                <List className="regexdash-content__ul">
                    {props.input.map(obj =>
                        checkValidation(obj.regex, obj.Message, obj.compareTo)
                    )}
                </List>
            </CardContent>
        </Card>
    )
}

RegexMatchDashboard.defaultProps = {
    value: '',
    input: [
        {regex: /^.{8,}$/, Message: 'Must be at least 8 characters in length'},
        {regex: /[0-9]/, Message: 'Must contain at least one number(0 through 9)'},
        {
            regex: /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]/,
            Message: 'Must contain at least one special character',
        },
        {
            regex: /[a-z]/,
            Message: 'Must contain at least one lower case letter(a-z)',
        },
        {
            regex: /[A-Z]/,
            Message: 'Must contain at least one upper case letter(A-Z)',
        },
        {
            regex: 'Compare',
            Message: 'Password and confirm password must be same',
        },
    ],
}

export default RegexMatchDashboard
